// In windows and ubuntu, we need these system fonts for emojis to work properly
// otherwise few of them will appear as black and white
const emojiFont = 'ExpensifyNeue-Regular, Segoe UI Emoji, Noto Color Emoji';

export default emojiFont;
